import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const FAQS = [{
  q: 'How does SPECIAL EDUCATION TEACHER PRO™ work?',
  a: 'After your purchase, you receive immediate digital access to all six modules and five strategic bonuses. Use the resources on your computer, tablet, or smartphone.'
}, {
  q: 'Is this a physical or digital product?',
  a: 'SPECIAL EDUCATION TEACHER PRO™ is fully digital. Nothing will be physically shipped. Access is available immediately after payment.'
}, {
  q: 'Is this designed for professional teachers?',
  a: 'Yes. SPECIAL EDUCATION TEACHER PRO™ is built for educators who already understand their profession and need practical resources, adaptable activities, visual supports, planning tools, and ready-to-use materials.'
}, {
  q: 'Can I use it with different support levels?',
  a: 'Yes. The resources can be adapted according to student skills, communication needs, independence, task complexity, support level, and educational objectives.'
}, {
  q: 'Can I use it for individual, small-group, and classroom support?',
  a: 'Yes. The system includes resources and structures for individual students, small groups, learning support, and classroom situations.'
}, {
  q: 'Can I adapt the material?',
  a: 'Yes. Every resource provides a professional foundation that you can adapt to your students, teaching approach, classroom environment, support needs, and objectives.'
}, {
  q: 'Are the five bonuses included?',
  a: 'Yes. During this offer, all five strategic bonuses are included at no additional cost.'
}, {
  q: 'How long will I have access?',
  a: 'Your purchase includes lifetime access to the materials included in your order.'
}, {
  q: 'What makes this different from free online resources?',
  a: 'Free activities and printables are usually scattered and disconnected. SPECIAL EDUCATION TEACHER PRO™ brings visual supports, activities, differentiation, routines, planning, progress tools, and practical resources into one professional system.'
}, {
  q: 'What if it is not right for me?',
  a: 'You are protected by a 7-day money-back guarantee. Open the modules, explore the visual supports, activities, and bonuses, and if the system is not right for your classroom, contact us within the guarantee period for a full refund.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-cream px-3 py-7 sm:px-5" data-id="element-66" data-mp="2dfp4je77rsay">
      <div className="mx-auto max-w-2xl" data-id="element-67" data-mp="2ddcjuta2n3u7">
        <h2 id="faq-title" className="text-center font-head text-2xl uppercase leading-none text-ink sm:text-4xl" data-id="element-68" data-mp="28hnj4mmbfgwb">
          Frequently Asked Questions
        </h2>

        <div className="mt-3 space-y-1.5" data-id="element-69" data-mp="1zg7kfc4v537x">
          {FAQS.map((item, index) => {
          const isOpen = open === index;
          return <div key={item.q} className="overflow-hidden rounded-lg border border-ink/10 bg-white" data-id="element-70" data-mp="s3f7vo6zwtzz" data-mpi={index}>
                <h3 data-id="element-71" data-mp="nzpk30y5agg0">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left text-[13px] font-bold text-ink sm:text-[15px]" data-id="element-72" data-mp="nz7kpvg6rm3v">
                    {item.q}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-petrol transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-73" data-mp="38okcpts6k47h" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-ink/10 px-3 py-2.5 text-[13px] leading-snug text-muted" data-id="element-74" data-mp="3iec6wmwdavbf">
                    {item.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}